import { defineComponent as _defineComponent } from 'vue'
import DateOpen from '@/components/svg/date-open-2.svg?inline';
import DateConfirmed from '@/components/svg/date-confirmed.svg?inline';
import DateCancelled from '@/components/svg/date-cancelled.svg?inline';
import { MeetingStatus } from '@/models/MeetingScheduler';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MeetingSectionItem',
  props: {
    title: null,
    description: null,
    status: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  description: string;
  status?: MeetingStatus;
};



const isInvalid = computed(() => props.status === 'CANCELLED' || props.status === 'EXPIRED');

return { __sfc: true,props, isInvalid, DateOpen, DateConfirmed, DateCancelled }
}

})